import { render, staticRenderFns } from "./com-order-list.vue?vue&type=template&id=3efe2ab7&"
import script from "./com-order-list.vue?vue&type=script&lang=js&"
export * from "./com-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports